import { render, staticRenderFns } from "./SegmentRow.vue?vue&type=template&id=63cc4aa7&scoped=true&lang=pug&"
import script from "./SegmentRow.vue?vue&type=script&lang=js&"
export * from "./SegmentRow.vue?vue&type=script&lang=js&"
import style0 from "./SegmentRow.vue?vue&type=style&index=0&id=63cc4aa7&scoped=true&lang=stylus&"
import style1 from "./SegmentRow.vue?vue&type=style&index=1&lang=stylus&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63cc4aa7",
  null
  
)

export default component.exports